const e = (r) => {
  switch (r) {
    case "success":
      return "border-green";
    case "error":
      return "border-danger";
    default:
      return "border-brand-primary";
  }
}, o = (r) => {
  switch (r) {
    case "success":
      return "hover:fill-green group-focus-visible:fill-green";
    case "error":
      return "hover:fill-danger group-focus-visible:fill-danger";
    default:
      return "hover:fill-brand-primary group-focus-visible:fill-brand-primary";
  }
};
export {
  e as getBorderColor,
  o as getCloseIconColors
};
